import { ref } from 'vue';
import client from '@/sanityClient';

export function useSitePage() {
  const pages = ref([]);
  const page = ref(null);
  const loading = ref(false)
  const error = ref(null);

  // Fetch all pages
  const fetchAllPages = async () => {
    try {
      const query = `*[_type == "page"]{ title, slug, _updatedAt }`;
      pages.value = await client.fetch(query);
    } catch (err) {
      error.value = 'Failed to load pages';
      console.error(err);
    }
  };

  // Fetch a specific page by slug
  const fetchPageBySlug = async (slug) => {
    try {
      loading.value = true
      const query = `*[_type == "page" && slug.current == $slug][0]{ title, content, _updatedAt }`;
      page.value = await client.fetch(query, { slug });
    } catch (err) {
      error.value = `Failed to load page with slug: ${slug}`;
      console.error(err);
    } finally {
      loading.value = false
    }
  };

  return {
    pages,
    page,
    loading,
    error,
    fetchAllPages,
    fetchPageBySlug,
  };
}
